import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getAuthUser } from '../../helpers';
import { Loading, TooltipWrapper } from '../common'
import { Chain } from '../../models'
import { getChain } from '../../api'
import { EditChainForm } from './edit'
import { ChainTable } from './resourceTable'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../common';

export const ChainCard = () => {
    const [chain, setChain] = useState<Chain>()
    const [isEditing, setIsEditing] = useState(false)
    const params = useParams()
    const ability = defineAbilityFor(getAuthUser())

    useEffect(() => {
        if (params.chainId && ability.can('View', 'Chain')) {
            getChain(params.chainId)
                .then(response => {
                    if (response.status === 200) {
                        setChain(new Chain(response.data))
                    }
                })
        }
    }, [params.chainId])

    if (!ability.can('View', 'Chain')) {
        return <InsufficientPermissions />
    }

    if (!(chain instanceof Chain)) {
        return <Loading />
    }

    return (
        <div className='container card col-xs-12 col-xl-6'>
            <div className='card-body col-xs-12 row d-flex flex-row justify-content-between mb-5'>
                <div className='row flex-row mb-5'>
                    <h3 className='ps-0 d-inline-flex card-title w-50'>
                        {chain.name}
                    </h3>
                    <div className='pe-0 d-inline-flex justify-content-end w-50'>
                        <TooltipWrapper
                            condition={!ability.can('Edit', 'Chain')}
                            element={
                                <button
                                    className='btn btn-primary'
                                    disabled={!ability.can('Edit', 'Chain')}
                                    onClick={() => setIsEditing(!isEditing)}>
                                    Toggle Edit
                                </button>
                            }
                            message='Executive permission required to edit chain' />
                    </div>
                </div>
                {!isEditing && <ChainTable chain={chain} />}
                {isEditing && (
                    <EditChainForm
                        chain={chain}
                        setIsEditing={setIsEditing}
                        setChain={setChain} />
                )}
            </div>
        </div>
    )
}
